module.exports = __webpack_public_path__ + "img/heart_13.daf60bf0.png";